module.exports = __webpack_public_path__ + "static/dyrket_logo-74904c8cdb00ecc52eae238a551301d5.png";